import { render, staticRenderFns } from "./departmentChoose.vue?vue&type=template&id=b9c76cf6&"
import script from "./departmentChoose.vue?vue&type=script&lang=js&"
export * from "./departmentChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports